import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faClose,
  faQuestion,
  faSpinner,
  faWarning,
} from "@fortawesome/free-solid-svg-icons";
import StatusBadge from "../../../components/StatusBatch";
import PillNavigation from "../../../components/SubNavBar";
import { Button, Card, CardBody, Modal } from "react-bootstrap";
import { TabContent, TabPane } from "reactstrap";
import BreadCrumbs from "../../../components/BreadCrumbs";
import "./index.css";
import {
  useLazyGetCartDetailsByIdQuery,
  useUpdateCartStatusMutation,
} from "../../../redux/services/cartSearchService";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { NAV_LIST_CART_VIEW } from "../../../constants/constans";
import CartDetails from "./CartDetails";
import Restaurants from "./Restaurants";
import CartPerson from "./CartPerson";
import Inventory from "./Inventory";
import RestaurantSalesList from "./Sales";
import CartMapView from "../../../components/CartsLocationMap";

const CartView = () => {
  const navigate = useNavigate();

  const cart = useSelector((state: any) => state?.cart?.selectedCart);

  const [active, setActive] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [isUpdateLoading, setIsUpdateLoading] = useState(false);
  const [clickedButton, setClickedButton] = useState("");

  const handleShowModal = () => setShowModal(true);

  const handleCloseModal = () => setShowModal(false);

  const [triggerCartDetails, { data: cartData }] =
    useLazyGetCartDetailsByIdQuery();

  useEffect(() => {
    if (cart.id) {
      triggerCartDetails(cart.id);
    }
  }, [cart.id, triggerCartDetails]);

  const [triggerUpdateCartList] = useUpdateCartStatusMutation();

  // const toggle = (tab: any) => {
  //   if ((tab === 3 && cart?.owner?.id === null) || tab === 2 && cart?.status === "Rejected") return;
  //   setActive(tab);
  // };
  const toggle = (tab: any) => {
    if (
      (tab === 3 && cart?.owner?.id === null) ||
      (tab === 2 && cart?.status === "Rejected")
    ) {
      return;
    }
    setActive(tab);
  };

  const handleStatusUpdate = async (status: string, buttonType: string) => {
    setIsUpdateLoading(true);
    setClickedButton(buttonType);
    const obj = {
      cartId: cart.id,
      cartStatus: status,
    };
    const response: any = await triggerUpdateCartList(obj);
    if (response.data === "OK") {
      toast.success(`Cart status updated to ${status}`);
      if (status === "Deleted") {
        navigate("/carts/carts-list");
      } else {
        triggerCartDetails(cart.id);
      }
      setIsUpdateLoading(false);
      setClickedButton("");
      handleCloseModal();
    } else {
      toast.error("Cart status could not be updated");
      setIsUpdateLoading(false);
      setClickedButton("");
    }
  };

  return (
    <>
      <BreadCrumbs hasSubMenus={true} />
      <br />
      <Card className="cart-view-whole-card">
        <CardBody>
          <div className="Cart-view-nav-bar">
            <PillNavigation
              navList={NAV_LIST_CART_VIEW.map((navItem, index) => {
                const isTabDisabled =
                  (index === 1 &&
                    (cartData?.status || cartData?.status) === "Rejected") ||
                  (index === 2 &&
                    (!cartData?.owner?.id || !cartData?.owner?.id));

                return {
                  ...navItem,
                  disabled: isTabDisabled,
                  className: isTabDisabled ? "disabled-tab" : "",
                };
              })}
              active={active}
              toggle={toggle}
            />

            <div className="d-flex gap-3">
              <StatusBadge status={cartData?.status || cart.status} />
            </div>
          </div>
          <hr />
          {cartData?.status === "Pending" && (
            <div className="cart-view-status-showing-backgorund">
              <div className="cart-view-status-showing-backgorund-left-content">
                <FontAwesomeIcon icon={faSpinner} spin />
                <h6>This Cart is Pending</h6>
              </div>
              <div className="cart-view-status-showing-backgorund-right-content">
                <Button
                  className="cart-view-status-showing-backgorund-change-status-btn"
                  onClick={handleShowModal}
                >
                  Change Status
                </Button>
              </div>
            </div>
          )}
          <TabContent activeTab={active} className="mt-4">
            {active === 1 && (
              <div className="sub-nav-bar-each-part">
                <TabPane tabId={1}>
                  <CartDetails />
                </TabPane>
              </div>
            )}
            {active === 2 && cartData?.status !== "Rejected" && (
              <div className="sub-nav-bar-each-part">
                <TabPane tabId={2}>
                  <Restaurants />
                </TabPane>
              </div>
            )}

            {active === 3 && (
              <div className="sub-nav-bar-each-part">
                <TabPane tabId={3}>
                  <CartPerson />
                </TabPane>
              </div>
            )}
            {active === 4 && (
              <div className="sub-nav-bar-each-part">
                <TabPane tabId={4}>
                  <Inventory />
                </TabPane>
              </div>
            )}
            {active === 5 && (
              <div className="sub-nav-bar-each-part">
                <TabPane tabId={5}>
                  <CartMapView />
                </TabPane>
              </div>
            )}
            {active === 6 && (
              <div className="sub-nav-bar-each-part">
                <TabPane tabId={6}>
                  <RestaurantSalesList />
                </TabPane>
              </div>
            )}
          </TabContent>
        </CardBody>
      </Card>

      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Change Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-between gap-2">
            {cartData?.status === "Pending" ? (
              <>
                <Button
                  className="change-status-btn"
                  onClick={() => handleStatusUpdate("Rejected", "reject")}
                  disabled={isUpdateLoading}
                >
                  {isUpdateLoading && clickedButton === "reject" ? (
                    <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                  ) : (
                    <FontAwesomeIcon icon={faClose} className="me-2" />
                  )}
                  Reject
                </Button>
                <Button
                  className="change-status-btn"
                  onClick={() => handleStatusUpdate("Approved", "approve")}
                  disabled={isUpdateLoading}
                >
                  {isUpdateLoading && clickedButton === "approve" ? (
                    <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                  ) : (
                    <FontAwesomeIcon icon={faCheck} className="me-2" />
                  )}
                  Approve
                </Button>
              </>
            ) : cartData?.status === "Approved" ? (
              <>
                <Button
                  className="change-status-btn"
                  onClick={() => handleStatusUpdate("Rejected", "reject")}
                  disabled={isUpdateLoading}
                >
                  {isUpdateLoading && clickedButton === "reject" ? (
                    <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                  ) : (
                    <FontAwesomeIcon icon={faClose} className="me-2" />
                  )}
                  Reject
                </Button>
                <Button
                  className="change-status-btn"
                  onClick={() => handleStatusUpdate("Deleted", "delete")}
                  disabled={isUpdateLoading}
                >
                  {isUpdateLoading && clickedButton === "delete" ? (
                    <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                  ) : (
                    <FontAwesomeIcon icon={faWarning} className="me-2" />
                  )}
                  Delete
                </Button>
                <Button
                  className="change-status-btn"
                  onClick={() => handleStatusUpdate("Pending", "pending")}
                  disabled={isUpdateLoading}
                >
                  {isUpdateLoading && clickedButton === "pending" ? (
                    <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                  ) : (
                    <FontAwesomeIcon icon={faQuestion} className="me-2" />
                  )}
                  Pending
                </Button>
              </>
            ) : cartData?.status === "Deleted" ? (
              <>
                <Button
                  className="change-status-btn"
                  onClick={() => handleStatusUpdate("Approved", "approve")}
                  disabled={isUpdateLoading}
                >
                  {isUpdateLoading && clickedButton === "approve" ? (
                    <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                  ) : (
                    <FontAwesomeIcon icon={faCheck} className="me-2" />
                  )}
                  Approve
                </Button>
                <Button
                  className="change-status-btn"
                  onClick={() => handleStatusUpdate("Pending", "pending")}
                  disabled={isUpdateLoading}
                >
                  {isUpdateLoading && clickedButton === "pending" ? (
                    <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                  ) : (
                    <FontAwesomeIcon icon={faQuestion} className="me-2" />
                  )}
                  Pending
                </Button>
                <Button
                  className="change-status-btn"
                  onClick={() => handleStatusUpdate("Rejected", "reject")}
                  disabled={isUpdateLoading}
                >
                  {isUpdateLoading && clickedButton === "reject" ? (
                    <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                  ) : (
                    <FontAwesomeIcon icon={faClose} className="me-2" />
                  )}
                  Reject
                </Button>
              </>
            ) : cartData?.status === "Rejected" ? (
              <>
                <Button
                  className="change-status-btn"
                  onClick={() => handleStatusUpdate("Approved", "approve")}
                  disabled={isUpdateLoading}
                >
                  {isUpdateLoading && clickedButton === "approve" ? (
                    <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                  ) : (
                    <FontAwesomeIcon icon={faCheck} className="me-2" />
                  )}
                  Approve
                </Button>
                <Button
                  className="change-status-btn"
                  onClick={() => handleStatusUpdate("Pending", "pending")}
                  disabled={isUpdateLoading}
                >
                  {isUpdateLoading && clickedButton === "pending" ? (
                    <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                  ) : (
                    <FontAwesomeIcon icon={faQuestion} className="me-2" />
                  )}
                  Pending
                </Button>
                <Button
                  className="change-status-btn"
                  onClick={() => handleStatusUpdate("Deleted", "delete")}
                  disabled={isUpdateLoading}
                >
                  {isUpdateLoading && clickedButton === "delete" ? (
                    <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                  ) : (
                    <FontAwesomeIcon icon={faWarning} className="me-2" />
                  )}
                  Delete
                </Button>
              </>
            ) : (
              <></>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CartView;
